/* eslint-disable import/first */
import '../css/landing/theme.scss';

// import Rails from '@rails/ujs';

import jQuery from 'jquery';
import countup from 'countup.js';

window.jQuery = jQuery;
window.$ = jQuery;
window.CountUp = countup;

import '../src/landing_plugins';
import '../src/landing/dropdown';
import '../src/esign_handler';
import '../src/landing/polyfills';
import '../src/landing/navbar';
import '../src/landing/modal';
import '../src/landing/smooth-scroll';
import '../src/landing/choices';
import '../src/landing/countup';
import '../src/landing/popovers';
import '../src/landing/fancybox';
import '../src/landing/allow_numeric';

window.confetti = require('canvas-confetti');

require.context('../css/img', true);
// Rails.start();
